/** Puzzle 1 **/
import backgroundPuzzle1 from "./img/puzzle1/puzzle1.png";
import backgroundSolvedPuzzle1 from "./img/puzzle1/puzzle1-solved.png";
import puzzle1Piece1 from './img/puzzle1/1.png';
import puzzle1Piece2 from './img/puzzle1/2.png';
import puzzle1Piece3 from './img/puzzle1/3.png';
import puzzle1Piece4 from './img/puzzle1/4.png';
import puzzle1Piece5 from './img/puzzle1/5.png';
import puzzle1Piece6 from './img/puzzle1/6.png';
/** Puzzle 2 **/
import backgroundPuzzle2 from "./img/puzzle2/puzzle2.png";
import backgroundSolvedPuzzle2 from "./img/puzzle2/puzzle2-solved.png";
import puzzle2Piece1 from "./img/puzzle2/1.png";
import puzzle2Piece2 from "./img/puzzle2/2.png";
import puzzle2Piece3 from "./img/puzzle2/3.png";
import puzzle2Piece4 from "./img/puzzle2/4.png";
import puzzle2Piece5 from "./img/puzzle2/5.png";
import puzzle2Piece6 from "./img/puzzle2/6.png";
import puzzle2Piece7 from "./img/puzzle2/7.png";
import puzzle2Piece8 from "./img/puzzle2/8.png";
import puzzle2Piece9 from "./img/puzzle2/9.png";
/** Puzzle 3 **/
import backgroundPuzzle3 from "./img/puzzle3/puzzle3.png";
import backgroundSolvedPuzzle3 from "./img/puzzle3/puzzle3-solved.png";
import puzzle3Piece1 from "./img/puzzle3/1.png";
import puzzle3Piece2 from "./img/puzzle3/2.png";
import puzzle3Piece3 from "./img/puzzle3/3.png";
import puzzle3Piece4 from "./img/puzzle3/4.png";
import puzzle3Piece5 from "./img/puzzle3/5.png";
import puzzle3Piece6 from "./img/puzzle3/6.png";
import puzzle3Piece7 from "./img/puzzle3/7.png";
import puzzle3Piece8 from "./img/puzzle3/8.png";
import puzzle3Piece9 from "./img/puzzle3/9.png";
import puzzle3Piece10 from "./img/puzzle3/10.png";
import puzzle3Piece11 from "./img/puzzle3/11.png";
import puzzle3Piece12 from "./img/puzzle3/12.png";
import puzzle3Piece13 from "./img/puzzle3/13.png";
import puzzle3Piece14 from "./img/puzzle3/14.png";
import puzzle3Piece15 from "./img/puzzle3/15.png";
import puzzle3Piece16 from "./img/puzzle3/16.png";
/** Puzzle 4 **/
import backgroundPuzzle4 from "./img/puzzle4/puzzle4.png";
import backgroundSolvedPuzzle4 from "./img/puzzle4/puzzle4-solved.png";
import puzzle4Piece1 from "./img/puzzle4/1.png";
import puzzle4Piece2 from "./img/puzzle4/2.png";
import puzzle4Piece3 from "./img/puzzle4/3.png";
import puzzle4Piece4 from "./img/puzzle4/4.png";
import puzzle4Piece5 from "./img/puzzle4/5.png";
import puzzle4Piece6 from "./img/puzzle4/6.png";
import puzzle4Piece7 from "./img/puzzle4/7.png";
import puzzle4Piece8 from "./img/puzzle4/8.png";
import puzzle4Piece9 from "./img/puzzle4/9.png";
import puzzle4Piece10 from "./img/puzzle4/10.png";
import puzzle4Piece11 from "./img/puzzle4/11.png";
import puzzle4Piece12 from "./img/puzzle4/12.png";
import puzzle4Piece13 from "./img/puzzle4/13.png";
import puzzle4Piece14 from "./img/puzzle4/14.png";
import puzzle4Piece15 from "./img/puzzle4/15.png";
import puzzle4Piece16 from "./img/puzzle4/16.png";

const GameState = {
	uninitialized: -1,
	playing: 0,
	levelAnswer: 3,
	done: 1,
	results: 2,
};

document.setDefaultFontSize = function() {
	const container = document.getElementById('game-container');
	const containerWidth = container.clientWidth;
	let fontSize = Math.round(20 * containerWidth / 1055);
	document.documentElement.style.setProperty('--default-font-size', `${fontSize}px`);
}

document.setGameContainerSize = function() {
	const width = window.innerWidth;
	const height = window.innerHeight;
	const container = document.getElementById('game-ratio-container');

	if (height < (width * 2.8 / 4)) {
		container.style.width = `${Math.floor(height * 4 / 2.8)}px`;
	} else {
		container.style.width = `${width}px`;
	}
}

document.computeSizes = function() {
	document.setGameContainerSize();
	document.setDefaultFontSize();
}

document.Game = {
	state: GameState.uninitialized,
	currentPuzzleIndex: 0,
	puzzles: [
		{
			background: backgroundPuzzle1,
			solvedBackground: backgroundSolvedPuzzle1,
			pieces: [{
				img: puzzle1Piece3,
				pos: 4,
			}, {
				img: puzzle1Piece4,
				pos: 1,
			}, {
				img: puzzle1Piece2,
				pos: 0,
			}, {
				img: puzzle1Piece5,
				pos: 5,
			}, {
				img: puzzle1Piece1,
				pos: 3,
			}, {
				img: puzzle1Piece6,
				pos: 2,
			}],
			description: `Les semelles orthopédiques amortissent les chocs et réduisent l’agression du cartilage. <br/>En cas d'arthrose du genou, ces semelles permettront d'en réduire de 40% les vibrations<sup>1</sup>.`,
			references: `1. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Les traitements de l’arthrose. Actualités Pharmaceutiques, 55(555), 23-29.`
		},
		{
			background: backgroundPuzzle2,
			solvedBackground: backgroundSolvedPuzzle2,
			pieces: [
				{
				img: puzzle2Piece3,
				pos: 6,
			}, {
				img: puzzle2Piece8,
				pos: 1,
			}, {
				img: puzzle2Piece4,
				pos: 5,
			}, {
				img: puzzle2Piece6,
				pos: 3,
			}, {
				img: puzzle2Piece1,
				pos: 8,
			}, {
				img: puzzle2Piece2,
				pos: 7,
			}, {
				img: puzzle2Piece5,
				pos: 4,
			}, {
				img: puzzle2Piece7,
				pos: 0,
			}, {
				img: puzzle2Piece9,
				pos: 2,
			}],
			description: `Il est important d’adapter son mode de vie en demandant conseil à son professionnel de santé.<br />Au bureau, par exemple, des coussins d’assise, des accoudoirs, des soutiens lombaires,<br/>des tabourets assis debout ergonomiques, des repose-jambes ou encore des repose-pieds peuvent être utilisés.<br />Ils assurent le confort et le maintien d’une bonne posture <sup>1</sup>.`,
			references: `1. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Les traitements de l’arthrose. Actualités Pharmaceutiques, 55(555), 23-29.`
		},
		{
			background: backgroundPuzzle3,
			solvedBackground: backgroundSolvedPuzzle3,
			pieces: [
				{
					img: puzzle3Piece1,
					pos: 12,
				},
				{
					img: puzzle3Piece4,
					pos: 0,
				},
				{
					img: puzzle3Piece14,
					pos: 11,
				},
				{
					img: puzzle3Piece13,
					pos: 15,
				},
				{
					img: puzzle3Piece9,
					pos: 14,
				},
				{
					img: puzzle3Piece10,
					pos: 10,
				},
				{
					img: puzzle3Piece5,
					pos: 1,
				},
				{
					img: puzzle3Piece15,
					pos: 7,
				},
				{
					img: puzzle3Piece3,
					pos: 4,
				},
				{
					img: puzzle3Piece11,
					pos: 6,
				},
				{
					img: puzzle3Piece8,
					pos: 13,
				},
				{
					img: puzzle3Piece16,
					pos: 3,
				},
				{
					img: puzzle3Piece2,
					pos: 8,
				},
				{
					img: puzzle3Piece7,
					pos: 9,
				},
				{
					img: puzzle3Piece6,
					pos: 5,
				},
				{
					img: puzzle3Piece12,
					pos: 2
				}
			],
			description: `Pratiquer régulièrement une activité physique telle que la marche est essentiel.<br />Les cannes et les béquilles sont utilisées dans l’arthrose du genou.<br />Elles permettent à l’articulation de se reposer. La canne doit être utilisée du côté opposé à l’articulation douloureuse,<br />afin de la décharger, de réduire la douleur et d’améliorer la mobilité et la sécurité <sup>1</sup>.`,
			references: `1. Lagorce, T., Buxeraud, J., & Guillot, X. (2016). Les traitements de l’arthrose. Actualités Pharmaceutiques, 55(555), 23-29.`
		},
		{
			background: backgroundPuzzle4,
			solvedBackground: backgroundSolvedPuzzle4,
			pieces: [
				{ img: puzzle4Piece1, pos: 12 },
				{ img: puzzle4Piece4, pos: 0 },
				{ img: puzzle4Piece14, pos: 11 },
				{ img: puzzle4Piece13, pos: 15 },
				{ img: puzzle4Piece7, pos: 9 },
				{ img: puzzle4Piece6, pos: 5 },
				{ img: puzzle4Piece5, pos: 1 },
				{ img: puzzle4Piece15, pos: 7 },
				{ img: puzzle4Piece3, pos: 4 },
				{ img: puzzle4Piece11, pos: 6 },
				{ img: puzzle4Piece8, pos: 13 },
				{ img: puzzle4Piece16, pos: 3 },
				{ img: puzzle4Piece2, pos: 8 },
				{ img: puzzle4Piece9, pos: 14 },
				{ img: puzzle4Piece10, pos: 10 },
				{ img: puzzle4Piece12, pos: 2 },
			],
			description: `La surcharge pondérale entraîne un excès de pression qui peut abîmer les structures articulaires.<br />Ainsi, une perte de poids en améliorant les habitudes de vie peut permettre de limiter<br />la progression de la maladie <sup>1</sup>.`,
			references: `2. Inserm (2012). Arthrose. [en ligne] https://www.inserm.fr/dossier/arthrose/ - consulté le 08.06.2022`,
		}
	],
	render() {
		// Hide all game state
		const gameStates = document.getElementsByClassName('game-state');
		for (let i = 0; i < gameStates.length; i++) {
			if (!gameStates[i].classList.contains('hidden')) {
				gameStates[i].classList.add('hidden');
			}
		}
		// Call method to prepare everything then display the current state
		switch (this.state) {
			case GameState.playing:
				this.renderPuzzle();
				document.getElementById('state-playing').classList.remove('hidden');
				break;
			case GameState.levelAnswer:
				this.renderPuzzleSolution();
				document.getElementById('state-level-solution').classList.remove('hidden');
				break;
			case GameState.done:
				document.getElementById('state-done').classList.remove('hidden')
				break;
			case GameState.results:
				document.getElementById('state-results').classList.remove('hidden')
				break;
		}
	},
	resetLevel() {
		this.showingReply = false;
		this.selectedItem = null;
		this.dropped = false;
		this.foundCount = 0;
		this.render();
	},
	getPuzzlePieceHtml(url, pos) {
		return `<div class="puzzle-piece-container" data-index="${pos}">
					<div class="puzzle-piece">
						<img src="${url}"/>
					</div>
				</div>`;
	},
	renderPuzzle() {
		const currentPuzzle = this.puzzles[this.currentPuzzleIndex];

		// Set background image
		const container = document.getElementById('state-playing');
		container.style.backgroundImage = `url('${currentPuzzle.background}')`;

		// Add class to indicate current puzzle for specific positionning css
		const gameContentContainer = document.getElementById('game-content');
		gameContentContainer.removeAttribute('class'); // Reset
		gameContentContainer.classList.add('puzzle-' + (this.currentPuzzleIndex + 1));

		// Fill pieces pool
		const piecesContainer = document.getElementById('puzzle-pieces-container');
		const piecesHtml = currentPuzzle.pieces.map((piece) => this.getPuzzlePieceHtml(piece.img, piece.pos));
		piecesContainer.innerHTML = piecesHtml.join('');

		// Create drop zones
		const puzzleDropArea = document.getElementById('puzzle-drop-area');
		const puzzleHtml = currentPuzzle.pieces.map((p, i) => `<div class="puzzle-drop" data-pos="${i}"></div>`);
		puzzleDropArea.innerHTML = puzzleHtml.join('');

		this.handleDragAndDrop();
	},
	showingReply: false,
	selectedItem: null,
	dropped: false,
	foundCount: 0,
	handleDragAndDrop() {
		const currentPuzzle = this.puzzles[this.currentPuzzleIndex];

		const pieces = document.getElementsByClassName('puzzle-piece-container');
		const dropZones = document.getElementsByClassName('puzzle-drop');

		for (let i = 0; i < pieces.length; i++) {
			pieces[i].addEventListener('dragstart', (ev) => {
				if (this.showingReply) {
					ev.preventDefault();
					return;
				}
				this.selectedItem = pieces[i];
				if (this.selectedItem.classList.contains('hidden-opacity')) {
					ev.preventDefault();
					this.selectedItem = null;
					return;
				}
				this.dropped = false;
				ev.dataTransfer.dropEffect = "move";

				// So it's called after dragstart ends and the item is copied without the class
				setTimeout(() => {
					this.selectedItem.classList.add('hidden-opacity');
				}, 0);
			});
			pieces[i].addEventListener('dragend', (ev) => {
				if (this.dropped) return;
				// Called after drop, reset css if not handled in drop
				this.selectedItem.classList.remove('hidden-opacity');
				this.selectedItem = null;
			});
		}

		for (let i = 0; i < dropZones.length; i++) {
			dropZones[i].addEventListener("dragover", (ev) => {
				ev.preventDefault();
				ev.dataTransfer.dropEffect = "move";
			});
			dropZones[i].addEventListener("drop", (ev) => {
				ev.preventDefault();
				if (dropZones[i].innerHTML.length) {
					return; // Zone already contains an item
				}
				this.dropped = true;
				const itemId = +this.selectedItem.dataset.index;
				const zonePos = +dropZones[i].dataset.pos;

				const success = itemId === zonePos;

				if (success) {
					dropZones[i].innerHTML = this.selectedItem.innerHTML;
					this.foundCount += 1;
					if (this.foundCount === currentPuzzle.pieces.length) {
						setTimeout(this.showPuzzleSolution.bind(this), 1000);
					}
					return;
				}
				this.showingReply = true;
				dropZones[i].classList.add('error');
				dropZones[i].innerHTML = this.selectedItem.innerHTML;

				// Show error toastr
				const errorDiv = document.createElement('div');
				errorDiv.innerHTML = "<strong>Oups !</strong> Ce n'est pas ici.";
				errorDiv.setAttribute("id", "error-message");
				dropZones[i].appendChild(errorDiv);

				setTimeout(() => {
					if (!this.selectedItem) {
						return; // Reset was called in between
					}
					dropZones[i].classList.remove('error');
					dropZones[i].innerHTML = '';
					this.showingReply = false;
					this.selectedItem.classList.remove('hidden-opacity');
					this.selectedItem = null;
				}, 2000);
			});
		}
	},
	restart() {
		this.currentPuzzleIndex = 0;
		this.state = GameState.playing;
		this.render();
	},
	showPuzzleSolution() {
		this.state = GameState.levelAnswer;
		this.render();
	},
	renderPuzzleSolution() {
		const currentPuzzle = this.puzzles[this.currentPuzzleIndex];

		const container = document.getElementById('state-level-solution');
		container.style.backgroundImage = `url(${currentPuzzle.solvedBackground})`;

		const description = document.getElementById('puzzle-solution-description');
		description.innerHTML = `<p>${currentPuzzle.description}</p>`;

		const references = document.getElementById('puzzle-solution-references');
		references.innerHTML = `Références:<br/>${currentPuzzle.references}`;
	},
	_loading: false,
	next() {
		if (this._loading) return;
		this._loading = true;
		this.state = GameState.playing;
		this.currentPuzzleIndex += 1;
		this.showingReply = false;
		this.selectedItem = null;
		this.dropped = false;
		this.foundCount = 0;
		if (this.currentPuzzleIndex === this.puzzles.length) {
			this.state = GameState.done;
		}
		this.render();
		this._loading = false;
	},
	seeResults() {
		this.state = GameState.results;
		this.render();
	}
}

document.computeSizes();
document.Game.restart();

addEventListener('resize', document.computeSizes);
